export default function GroupSettingsTopicRules({ form, onChange }) {
    return (
        <div id="group-settings-topic-rules">
            <div className="yns-section-label">Topic Rules</div>
            <div className="j-inspector-row">
                <span className="j-tooltip-label">Include</span>
                <input
                    className="j-inspector-select"
                    value={form.includePatterns || ''}
                    onChange={(e) => onChange('includePatterns', e.target.value)}
                    placeholder="Jerny.*, Journl.*"
                    maxLength={500}
                />
            </div>
            <div className="j-inspector-row">
                <span className="j-tooltip-label">Exclude</span>
                <input
                    className="j-inspector-select"
                    value={form.excludePatterns || ''}
                    onChange={(e) => onChange('excludePatterns', e.target.value)}
                    placeholder="*.Sessions"
                    maxLength={500}
                />
            </div>
        </div>
    );
}
